import React from "react";
import SEO from "@/components/site/SEO";

export default function Privacy() {
  return (
    <div className="bg-white text-brand-black">
      <SEO
        title="Privacy Policy"
        description="LotWise Home privacy policy — what information we collect through the contact form, how we use it, and how you can contact us about it."
        path="/privacy"
      />
      <section className="bg-brand-black text-white">
        <div className="mx-auto max-w-[900px] px-5 md:px-10 py-20 md:py-24">
          <div className="eyebrow text-white/60">Legal</div>
          <h1 className="mt-4 text-[36px] md:text-5xl font-bold tracking-tight">Privacy Policy</h1>
        </div>
      </section>
      <section className="bg-white">
        <div className="mx-auto max-w-[820px] px-5 md:px-10 py-16 md:py-24 space-y-6 text-[15.5px] leading-relaxed text-brand-gray">
          <p>
            LotWise Home respects the privacy of the real estate professionals, teams, and
            organizations that reach out through this website. This policy describes what
            information we collect, how we use it, and how you can contact us about it.
          </p>
          <h2 className="text-brand-black text-2xl font-bold pt-4">What we collect</h2>
          <p>
            When you submit a listing support request through our contact form, we collect the
            information you provide, which may include your name, business name, email address,
            phone number, location, website, listing volume, property types, service preferences,
            preferred timeline, and any notes you choose to include.
          </p>
          <h2 className="text-brand-black text-2xl font-bold pt-4">How we use it</h2>
          <p>
            Information submitted through the form is used to respond to your listing support
            request, coordinate service, and communicate about your project. It may also be used to
            improve our own service quality and to better understand where listing support demand is
            strongest across the regions we serve.
          </p>
          <h2 className="text-brand-black text-2xl font-bold pt-4">What we do not do</h2>
          <p>
            LotWise Home does not sell your information. We do not share it with unrelated third
            parties for marketing purposes. Information is retained only as long as reasonably
            necessary to support the working relationship or the requested response.
          </p>
          <h2 className="text-brand-black text-2xl font-bold pt-4">Cookies and analytics</h2>
          <p>
            The site may use minimal analytics to understand traffic and improve the experience. No
            attempt is made to combine that data with personally identifiable information without
            your consent.
          </p>
          <h2 className="text-brand-black text-2xl font-bold pt-4">Contact</h2>
          <p>
            To request changes, deletion, or details about your submission, email{" "}
            <a href="mailto:hello@lotwiseauto.ca" className="text-brand-black link-underline">hello@lotwiseauto.ca</a>.
          </p>
        </div>
      </section>
    </div>
  );
}
